<div class="flex-container">
    <div class="flex-center">
        <!-- <mat-icon class="icon">error</mat-icon> -->
        <h1 class="header">
            404
        </h1>
        <p class="paragraph">Oops! Page not found</p>
        <span class="text">Sorry, but the page you are looking for is not found. Please, make sure you have typed the current URL.</span>

        <button mat-flat-button color="red" class="signIn-button" (click)="backToSetting()">
            Back to settings
        </button>
    </div>
    
</div>
